import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px;
  
  @media (max-width: 768px) {
    padding: 16px;
  }
  
  @media (max-width: 375px) {
    padding: 12px;
    min-width: 260px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  margin-right: 16px;
  border-radius: 8px;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #f0f0f0;
  }
  
  svg {
    width: 24px;
    height: 24px;
    color: #666;
  }
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #1e2f23;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 100px; /* Space for fixed button */
`;

export const PhotoCarousel = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f5f5f5;
  
  @media (max-width: 768px) {
    height: 250px;
  }
  
  @media (max-width: 480px) {
    height: 200px;
  }
`;

export const CarouselImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const CarouselPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 16px;
  background-color: #f5f5f5;
`;

export const CarouselIndicators = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
`;

export const CarouselDot = styled.button<{ active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background-color: ${props => props.active ? '#e39435' : '#d0d0d0'};
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${props => props.active ? '#e39435' : '#b0b0b0'};
  }
`;

export const PreviewCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    padding: 20px;
  }
  
  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const ItemName = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #1e2f23;
  margin: 0 0 12px 0;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
  
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const ItemPrice = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #e39435;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const ItemDescription = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin: 0 0 16px 0;
  
  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const CategoryTag = styled.span`
  display: inline-block;
  background-color: #f0f8ff;
  color: #2ca7c1;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
  
  @media (max-width: 480px) {
    font-size: 12px;
    padding: 4px 8px;
  }
`;

export const OptionGroupsSection = styled.div`
  margin-top: 20px;
`;

export const OptionGroupsTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1e2f23;
  margin: 0 0 12px 0;
  
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const OptionGroupsSummary = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  
  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const OptionGroup = styled.div`
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const OptionGroupName = styled.span`
  font-weight: 600;
  color: #1e2f23;
`;

export const OptionGroupOptions = styled.span`
  color: #666;
`;

export const CreateButton = styled.button`
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  height: 56px;
  background: linear-gradient(135deg, #e39435 0%, #f4a261 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(227, 148, 53, 0.3);
  z-index: 1000;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(227, 148, 53, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
  
  @media (max-width: 768px) {
    bottom: 16px;
    left: 16px;
    right: 16px;
    height: 52px;
    font-size: 15px;
  }
  
  @media (max-width: 375px) {
    bottom: 12px;
    left: 12px;
    right: 12px;
    height: 48px;
    font-size: 14px;
    min-width: 260px;
    margin: 0 auto;
  }
`;

export const LoadingSpinner = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const SuccessMessage = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  text-align: center;
  z-index: 2000;
  min-width: 300px;
  
  @media (max-width: 480px) {
    margin: 0 20px;
    min-width: auto;
    padding: 24px;
  }
`;

export const SuccessIcon = styled.div`
  width: 64px;
  height: 64px;
  background: #4caf50;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  
  svg {
    width: 32px;
    height: 32px;
    color: white;
  }
`;

export const SuccessTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #1e2f23;
  margin: 0 0 8px 0;
`;

export const SuccessText = styled.p`
  font-size: 16px;
  color: #666;
  margin: 0;
  line-height: 1.4;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1500;
`;
